export default () => ({
  selectedCountry: null,

  init() {
    // Parse the language data from the JSON script tag
    this.languageData = JSON.parse(this.$refs.languageData.textContent);
    this.setLangs();
  },

  setLangs() {
    const languageSelect = this.$refs.languageSelect;
    if (!languageSelect) return;

    // Get available languages for selected country
    const availableLanguages = this.languageData[this.selectedCountry] || [];

    // Clear existing options
    while (languageSelect.firstChild) {
      languageSelect.removeChild(languageSelect.firstChild);
    }

    // Add new options
    availableLanguages.forEach((lang) => {
      const option = document.createElement("option");
      option.value = lang.iso_code;
      option.textContent = lang.endonym_name;
      languageSelect.appendChild(option);
    });
  }
});
